export default __webpack_public_path__ + "static/media/calendar.3a0acbd4.svg";